module.exports = __webpack_public_path__ + "static/media/map_v2-07.d39a53f9.svg";